module.exports = __webpack_public_path__ + "static/media/Gotham-Light.0ff4bccb.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Gotham-Light.otf
 ** module id = 1339
 ** module chunks = 0
 **/